import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { Subscription, first } from 'rxjs';
import { InventoryDialogComponent } from '../inventory-dialog/inventory-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { OptionsService } from '@app/services/options/options.service';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import { selectCountsState, selectCountsCurrentInventoryState } from '../store/selectors/counts.selectors';
import * as CountsActions from '../store/actions/counts.actions';
import { selectSettingsState, } from '@app/modules/settings/store/selectors/settings.selectors';
import { MatTableDataSource } from '@angular/material/table';
import { SendMailModalComponent } from '@app/shared/components/send-mail-modal/send-mail-modal.component';

@Component({
  selector: 'app-print-count',
  templateUrl: './print-count.component.html',
  styleUrls: ['./print-count.component.scss']
})
export class PrintCountComponent implements OnInit, OnDestroy {
  public dataSource: MatTableDataSource<any>
  public inventorySub: Subscription;
  public isFinalizedScreen = this._inventory.isFinalizeScreen();
  public optionsSub: Subscription;
  public columns = [
    { columnDef: 'prdNameEn', header: 'Item' },
    { columnDef: 'productStorageName', header: 'Product Storage' },
    { columnDef: 'prdCasePack', header: 'UOM' },
    { columnDef: 'invitmCount', header: 'Count' },
    { columnDef: 'pcmDesc', header: 'Count Type' },
  ];
  public inventory$;
  public displayedColumns = this.columns.map(c => c.columnDef);
  public tableColumns = this.columns.map(c => c.header);
  public invData;
  public invOption;
  public count: number = 0;
  public sum: number = 0;
  public options$;
  public form: FormGroup;
  public type: string = "master";
  public subs = new SubSink;
  private id;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private _inventory: InventoryService,
    private _dialogRef: MatDialogRef<InventoryDialogComponent>,
    private _router: Router,
    private _options: OptionsService,
    private _matDialog: MatDialog,
    private store$: Store
  ) {
    this.subs.add(this.store$.select(selectCountsState).subscribe(res => this.id = res.currentId));
    this.subs.add(this.store$.select(selectSettingsState).subscribe((settings) => {
      this.options$ = settings
      this.type = 'default';
      this.form = new FormGroup({ type: new FormControl(this.type) });
    }));

    this.store$.dispatch(CountsActions.loadPrintCount({
      name: 'default',
      invID: this.id,
      active: 'prdNameEn',
      direction: 'asc'
    }));
  }

  ngOnInit(): void {
    this.subs.add(this.store$.select(selectCountsCurrentInventoryState).subscribe((currentInventory) => {
      this.dataSource = new MatTableDataSource(currentInventory.invItems);
      this.inventory$ = currentInventory.inv;
      this.count = currentInventory.count;
      this.sum = currentInventory.sum;
    }));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  public buildTable() {
    const table = document.createElement('table');
    table.classList.add('export-table');
    const thead = document.createElement('thead');

    table.appendChild(thead);
    const trHead = document.createElement('tr');
    thead.appendChild(trHead);
    for (const h of this.tableColumns) {
      const th = document.createElement("th");
      th.style.background = 'red';
      trHead.appendChild(th).
        appendChild(document.createTextNode(h));
    }

    const tbody = document.createElement('tbody');
    table.append(tbody);
  }

  public generatePDF() {
    this._inventory.generatePrintCountPDF(this.type, this.sort.active ? this.sort.active : 'prdNameEn', this.sort.direction ? this.sort.direction : 'asc', this.isFinalizedScreen ? 1 : 0);
  }

  public onNavigate(prdID) {
    this._dialogRef.close();
    this._router.navigate([`/products/${prdID}`]);
  }

  private compare(a: any | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  public onSetType(event) {
    this.type = event.value;
    this.store$.dispatch(CountsActions.loadPrintCount({
      name: event.value,
      invID: this.id
    }));
  }

  public onSortData(sort: Sort) {
    this.store$.dispatch(CountsActions.loadPrintCount({
      invID: this.id,
      active: sort.active,
      direction: sort.direction
    }));
  }

  sendReport() {
    const dialog = this._matDialog.open(SendMailModalComponent, {
      minWidth: '30vw',
      maxWidth: '700px',
    });

    dialog.afterClosed().pipe(first()).subscribe(res => {
       if(res!=null && res.email!=null && res.email!=''){
        const data = {
          email: res.email,
          id: this.id,
          print_type:this.type,
          finalized: this._inventory.isFinalizeScreen() ? 1 : 0,
          type: 'countSheet'
        }

          this._inventory.onSendReportPDF(data);
        }
    });
  }

}

